<template>
  <div>
    <el-select
      v-close-on-zoom
      :value="state.selectedMonitors"
      placeholder="any monitor"
      :filterable="true"
      :multiple="true"
      :disabled="readonly"
      class="monitor-select"
      @input="keys => selectMonitors(keys)"
    >
      <el-option
        v-for="monitor in monitors"
        :key="monitor.key"
        :value="monitor.key"
        :label="monitor.label.en"
      />
    </el-select>
  </div>
</template>

<script>
import get from 'lodash/get';

export default {
  name: 'monitor-vitals-action',
  props: [
    'readonly',
    'emitter',
    'ikey',
    'getData',
    'putData',
    'control',
    'valueBool',
  ],
  data() {
    return {
      state: {
        selectedMonitors: [],
      },
      monitors: [
        {
          key: 'ETCO2',
          label: {
            en: 'ETCO2',
          },
        },
        {
          key: 'SPO2',
          label: {
            en: 'SPO2',
          },
        },
        {
          key: 'HEART_RATE',
          label: {
            en: 'Heart Rate',
          },
        },
      ],
    };
  },
  mounted() {
    const data = this.getData(this.ikey);
    this.state.selectedMonitors = get(data, 'vitals') || [];
    this.update();
  },
  methods: {
    selectMonitors(keys) {
      this.state.selectedMonitors = keys;
      this.update();
    },
    update() {
      this.putData(this.ikey, {
        type: 'VITALS',
        id: 'VITALS',
        category: 'monitor',
        vitals: this.state.selectedMonitors,
        valueBool: this.valueBool,
      });
      this.emitter.trigger('process', this.control);
    },
  },
};
</script>

<style>
</style>
